import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {QuotationService} from "../../../../services/quotation-service/quotation.service";
import {ValidationService} from "../../../../services/validation-service/validation.service";
import {LeadService} from "../../../../services/lead-service/lead.service";
import {WebLeadType} from "../../../../model/leads/WebLeadType";
import {GtmService} from '../../../../services/gtm-service/gtm.service';

declare var $: any;
declare let jQuery: any;
declare let jcf:any

@Component({
  selector: 'app-main-driver-details',
  templateUrl: './main-driver-details.component.html'
})
export class MainDriverDetailsComponent implements OnInit {

  constructor(public router: Router,
              public quotationService: QuotationService,
              public leadService: LeadService,
              public validationService: ValidationService,
              private gtmService: GtmService) { }

  ngOnInit() {
    this.reloadJCF();
  }

  private reloadJCF() {
    jQuery(function () {
      // @ts-ignore
      jcf.replaceAll();
    });
  }

  updateLeadWithPartialDriverInfo(fieldValue: string, fieldName: string) {
    this.fireAbandonmentTrackingEvent(fieldValue, fieldName);
    if (this.readyToUpdatePartialDriverInfo && this.leadService.secondaryDriver !== this.partialDriverInfo) {
      this.leadService.secondaryDriver = this.partialDriverInfo;
      this.leadService.updateLead(WebLeadType.WEB_LEAD_3).subscribe();
    }
  }

  get readyToUpdatePartialDriverInfo() {
    return this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.firstName != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.surname != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.cellphoneNumber != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.legalRefValue != null
  }

  get partialDriverInfo() {
    return 'Name:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.firstName
      + '|Surname:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.surname
      + '|Cell no:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.cellphoneNumber
      + '|ID/Passport:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.legalRefValue;
  }

  updateLeadWithFullDriverInfo(fieldValue: string, fieldName: string) {
    this.fireAbandonmentTrackingEvent(fieldValue, fieldName);
    if (this.readyToUpdateFullDriverInfo && this.leadService.secondaryDriver !== this.fullDriverInfo) {
      this.leadService.secondaryDriver = this.fullDriverInfo;
      this.leadService.updateLead(WebLeadType.WEB_LEAD_3).subscribe();
    }
  }

  get readyToUpdateFullDriverInfo() {
    return this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.firstName != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.surname != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.cellphoneNumber != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.legalRefValue != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.emailAddress != null &&
      this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.yearsAtPreviousInsurerCd != null &&
      (this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.legalRefTypeCd === 1 ||
        (this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.legalRefTypeCd === 2 &&
          this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.dateOfBirth != null &&
          this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.gender != null));
  }

  get fullDriverInfo() {
    const driverYearsPrevInsurer = this.quotationService.yearsAtPreviousInsurerSelectItemList.find(item =>
      item.key === this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.yearsAtPreviousInsurerCd).label;

    let fullDriverInfo = 'Name:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.firstName
      + '|Surname:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.surname
      + '|Cell no:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.cellphoneNumber
      + '|Email:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.emailAddress
      + '|YrsPrevInsurer:' + driverYearsPrevInsurer
      + '|ID/Passport:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.legalRefValue

    if (this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.legalRefTypeCd === 2) {
      fullDriverInfo += '|DOB:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.dateOfBirth
        + '|Gender:' + this.quotationService.getQuoteVehicleAndDriverDetails.primaryDriver.gender
    }

    return fullDriverInfo;
  }

  fireAbandonmentTrackingEvent(fieldValue: string, fieldName: string) {
    if (fieldValue && !this._isAbandonmentTrackingFired(fieldName)) {
      this.gtmService.formName = 'insure_60_second_quote';
      this.gtmService.postGtmEvent('form_abandoned', fieldName, 2);
      this._setTrackingFiredOnField(fieldName);
    }

  }

  private _setTrackingFiredOnField(fieldName: string) {
    switch (fieldName) {
      case 'primaryDriverName' : {
        this.gtmService.primaryDriverNameAbandonmentTrackingFired = true;
        break;
      }
      case 'primaryDriverSurname' : {
        this.gtmService.primaryDriverSurnameAbandonmentTrackingFired = true;
        break;
      }
      case 'primaryDriverCellNumber' : {
        this.gtmService.primaryDriverCellNumberAbandonmentTrackingFired = true;
        break;
      }
      case 'primaryDriverEmail' : {
        this.gtmService.primaryDriverEmailAbandonmentTrackingFired = true;
        break;
      }
      case 'primaryDriverIdNumber' : {
        this.gtmService.primaryDriverIdNumberAbandonmentTrackingFired = true;
        break;
      }
      case 'primaryDriverPassportNumber' : {
        this.gtmService.primaryDriverPassportNumberAbandonmentTrackingFired = true;
        break;
      }
      case 'primaryDriverDateOfBirth' : {
        this.gtmService.primaryDriverDateOfBirthAbandonmentTrackingFired = true;
        break;
      }
      case 'primaryDriverGender' : {
        this.gtmService.primaryDriverGenderAbandonmentTrackingFired = true;
        break;
      }
      case 'primaryDriverYearsWithPreviousInsurer' : {
        this.gtmService.primaryDriverYearsWithPreviousInsurerAbandonmentTrackingFired = true;
        break;
      }
    }
  }

  private _isAbandonmentTrackingFired(fieldName: string): boolean {
    switch (fieldName) {
      case 'primaryDriverName' : return this.gtmService.primaryDriverNameAbandonmentTrackingFired;
      case 'primaryDriverSurname' : return this.gtmService.primaryDriverSurnameAbandonmentTrackingFired;
      case 'primaryDriverCellNumber' : return this.gtmService.primaryDriverCellNumberAbandonmentTrackingFired;
      case 'primaryDriverEmail' : return this.gtmService.primaryDriverEmailAbandonmentTrackingFired;
      case 'primaryDriverIdNumber' : return this.gtmService.primaryDriverIdNumberAbandonmentTrackingFired;
      case 'primaryDriverPassportNumber' : return this.gtmService.primaryDriverPassportNumberAbandonmentTrackingFired;
      case 'primaryDriverDateOfBirth' : return this.gtmService.primaryDriverDateOfBirthAbandonmentTrackingFired;
      case 'primaryDriverGender' : return this.gtmService.primaryDriverGenderAbandonmentTrackingFired;
      case 'primaryDriverYearsWithPreviousInsurer' : return this.gtmService.primaryDriverYearsWithPreviousInsurerAbandonmentTrackingFired;
    }
  }

}

